/**
 * The films a visitor can watch from the landing's Videos window, in list
 * order. Every narrated film in scripts/media/films/registry.ts is here
 * (tests/ui/videoLibrary.test.tsx keeps the two in step). `title` is the
 * English source of the list row's name, translated like the rest of the
 * landing.
 */
export const LANDING_FILMS = [
  { id: "why-us", title: "Why Smart Manager" },
  { id: "home", title: "Just ask" },
  { id: "start", title: "Getting started" },
  { id: "pricing", title: "Pricing" },
  { id: "network", title: "Network" },
  { id: "meetings", title: "Meetings" },
  { id: "gestures", title: "Gestures" },
] as const;

export type LandingFilm = (typeof LANDING_FILMS)[number];
export type LandingFilmId = LandingFilm["id"];

/** The film the hero's button opens, and the window's pick when nothing chose one. */
export const DEFAULT_LANDING_FILM: LandingFilmId = "why-us";
